export const initCalltouch = ( form ) => {
	let calltouchPhone, calltouchData = [];

	Array.from( form.querySelectorAll( 'input:not([name="agreement"])' ) ).forEach( ( it ) => {
		if ( it.name === 'tel' )
		{
			calltouchPhone = it.value.replace( /\D/g, '' );
		}
		else
		{
			if ( calltouchData.length < 5 )
			{
				calltouchData.push( {
					name: it.name,
					value: it.value
				} );
			}
		}
	} );

	if ( !calltouchPhone || !window.ctw )
	{
		return;
	}

	window.ctw.createRequest( 'all_form', calltouchPhone, calltouchData, ( success, data ) => { console.log( success, data ) }, null, [] );
};


//////////////////
// WEBPACK FOOTER
// ./app/Common/Forms/initCalltouch.js
// module id = L3zT
// module chunks = 12